import React from 'react';

const variants = {
  success: 'bg-green-100 text-green-800',
  danger:  'bg-red-100 text-red-800',
  warning: 'bg-amber-100 text-amber-800',
  info:    'bg-blue-100 text-blue-800',
  gray:    'bg-gray-100 text-gray-700',
};

export function Badge({ variant = 'gray', children, className = '' }) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
      ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
}
